import { Form, Modal, Stack } from "react-bootstrap";
import { useMemo } from "react";
import BreakKeywords from "../Breaks/BreakKeywords";
import BreakContentGroups from "../Breaks/BreakContentGroups";
import moment from "moment/min/moment-with-locales";
import { getSongScoreColorCss, toAutoDecimals } from "../HelperFunctions";
import DataDescription from "../DataDescription";
import { useOnKeyEventPress } from "../HelperHooks";

export default function ClocksBreaksContentModal({ onHide, show, breakItem, breakContentData, radioId, setBreaksContentData, onBreakChange }) {
    const breakContent = useMemo(() => breakContentData.find(x => x.break_id === breakItem.break_id), [breakItem, breakContentData]);
    const breakIndex = useMemo(() => breakContentData.findIndex(x => x.break_id === breakItem.break_id), [breakItem, breakContentData]);
    const breakName = useMemo(() => (breakItem.title.trim() ? `${breakItem.artist} - ${breakItem.title}` : `Break ${breakItem.artist}`), [breakItem]);

    function onKeywordsUpdate(keywords) {
        setBreaksContentData(current => current.map(b => (b.break_id === breakItem.break_id ? { ...b, keywords } : b)));
    }
    function onContentGroupsUpdate(contentGroups) {
        setBreaksContentData(current => current.map(b => (b.break_id === breakItem.break_id ? { ...b, content_groups: contentGroups } : b)));
    }

    useOnKeyEventPress(
        () => onBreakChange(breakContentData[breakIndex < breakContentData.length - 1 ? breakIndex + 1 : 0].break_id),
        "ArrowRight",
        false,
        false,
        ".clocks-breaks-content-modal"
    );
    useOnKeyEventPress(
        () => onBreakChange(breakContentData[breakIndex ? breakIndex - 1 : breakContentData.length - 1].break_id),
        "ArrowLeft",
        false,
        false,
        ".clocks-breaks-content-modal"
    );

    if (!breakContent) return;

    return (
        <Modal size="lg" show={show && breakItem && breakContent} onHide={onHide} className="clocks-breaks-content-modal" centered>
            <Modal.Header closeButton>
                <Modal.Title className=" d-flex column-gap-3">
                    <div
                        className={`align-self-center score score-lg ${getSongScoreColorCss(breakContent.score, true)} ${
                            breakContent.invalid ? "invalid" : ""
                        }`}>
                        {toAutoDecimals(breakContent.score, 1)}
                    </div>
                    <Stack>
                        <h4 className=" mb-0">{breakName}</h4>
                        <DataDescription className="text-muted fs-7">
                            <DataDescription.Simple
                                label="Time"
                                value={`${moment(breakContent.start_datetime).format("LTS")} - ${moment(breakContent.end_datetime).format("LTS")}`}
                            />
                            <DataDescription.Simple
                                label="Duration"
                                value={`${moment.utc(moment.duration(breakContent.duration, "seconds").asMilliseconds()).format("m:ss")}`}
                            />
                        </DataDescription>
                    </Stack>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4 d-flex">
                <Stack gap={2} className=" flex-grow-1">
                    <h6 className="mb-0 fw-bold">Content Groups</h6>
                    <BreakContentGroups item={breakContent} onContentGroupsUpdate={onContentGroupsUpdate} radioId={radioId} />
                    <h6 className="mt-3 mb-0 fw-bold">Synopsis</h6>
                    <p className="mb-0 flex-grow-1">{breakContent.synopsis}</p>
                    <h6 className="mt-3 mb-0 fw-bold">Keywords</h6>
                    <BreakKeywords item={breakContent} onKeywordsUpdate={onKeywordsUpdate} />
                    <div className="d-flex flex-column align-items-center">
                        <ul className="list-group list-group-horizontal ra-page-indicator flex-wrap justify-content-center">
                            {breakContentData
                                .sort((a, b) => new Date(a.start_datetime) - new Date(b.start_datetime))
                                .map((x, i) => (
                                    <li className="list-group-item border-0" key={x.break_id}>
                                        <Form.Check
                                            name="breaks"
                                            id={x.break_id}
                                            type="radio"
                                            aria-label={`Break ${i + 1}`}
                                            checked={x.break_id === breakItem.break_id}
                                            onChange={() => onBreakChange(x.break_id)}
                                        />
                                    </li>
                                ))}
                        </ul>
                        <span>
                            {breakIndex + 1} / {breakContentData.length}
                        </span>
                    </div>
                </Stack>
            </Modal.Body>
        </Modal>
    );
}
